import React, { Component } from 'react'
import Home from './home/index.jsx'
import Cooperation from './cooperation/index.jsx'
import Relation from './relation/index.jsx'
import Journalism from './journalism/index.jsx'
import We from './We/index.jsx'
import Longin from './longin/index.jsx'
import Shengtai from './shengtai/index.jsx'
import Product from './product/index.jsx'
import Solution from './solution/index.jsx'
import PressCenter from './pressCenter/index.jsx'
import HardwareProduct from './product/hardwareProduct/index.jsx'
import Hardware from './product/hardwareProduct/hardware/index.jsx'
import Hezuo from './We/hezuo/index.jsx'
import News from './news/index.jsx'
import Zhuanli from './We//zhuanli/index.jsx'
import { Routes, Route } from 'react-router-dom'
import withRouter from './Components/withRouter/index'

class app extends Component {
  UNSAFE_componentWillReceiveProps() {
    window.scrollTo(0, 0)
  }
  render() {
    return (
      <div style={{ width: '100%' }}>
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/cooperation.html" element={<Cooperation />}></Route>
          <Route path="/contactus.html" element={<Relation />}></Route>
          <Route path="/product/solution/:id.html" element={<Journalism />}></Route>
          <Route path="/product.html" element={<Product />}></Route>
          <Route path="/product/hardware.html" element={<HardwareProduct />}></Route>
          <Route path="/product/solution.html" element={<Solution />}></Route>

          <Route path="/product/hardware/:id.html" element={<Hardware />}></Route>
          <Route path="/aboutus.html" element={<We />}></Route>
          <Route path="/aboutus/honorary.html" element={<Hezuo />}></Route>
          <Route path="/aboutus/idea.html" element={<Zhuanli />}></Route>
          <Route path="/aboutus/ecology.html" element={<Shengtai />}></Route>
          <Route path="/news.html" element={<PressCenter />}></Route>
          <Route path="/news/:id.html" element={<News />}></Route>
          <Route path="/longin.html" element={<Longin />}></Route>
        </Routes>
      </div>
    )
  }
}
export default withRouter(app)
